'use client';

import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import { cn } from '../../helpers/shadcnUtils.helper';

interface SwitchProps
  extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> {
  label?: string;
  labelPosition?: 'left' | 'right';
}

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  SwitchProps
>(({ className, label, labelPosition = 'right', ...props }, ref) => (
  <div
    className={cn(
      'flex w-full items-center gap-2 justify-between',
      labelPosition === 'left' && 'flex-row-reverse ',
    )}
  >
    {label && (
      <label className="text-sm font-medium text-foreground" htmlFor={props.id}>
        {label}
      </label>
    )}
    <SwitchPrimitives.Root
      className={cn(
        'peer inline-flex h-8 w-14 shrink-0 cursor-pointer items-center rounded-full transition-colors  disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-blue-50 data-[state=unchecked]:bg-neutral-98 px-1 hover:data-[state=unchecked]:bg-blue-95',
        className,
      )}
      {...props}
      ref={ref}
      id={props.id}
    >
      <SwitchPrimitives.Thumb
        className={cn(
          'pointer-events-none block h-6 w-6 rounded-full bg-white  transition-transform data-[state=checked]:translate-x-6 data-[state=unchecked]:translate-x-0',
        )}
      />
    </SwitchPrimitives.Root>
  </div>
));
Switch.displayName = 'Switch';

export { Switch };
